import React, {useState} from 'react';
import Select from "../../../componentsReusable/Select";
import useDidMountEffect from "../../../utils/useDidMountEffect";
import apiUser from "../../../apiUser";
import useAfterUpdateEffect from "../../../utils/useAfterUpdateEffect";
import {useTecRmi} from "../../../contexts/TecRmiContext";

const BodyForTimesSelect = props => {
  const { getApiPrimaryParams } = useTecRmi()
  const [value, setValue] = useState(props.value)
  const [bodiesForTimes, setBodiesForTimes] = useState([])

  useDidMountEffect(() => {
    apiUser.tecRmi.times.bodiesForTimes(getApiPrimaryParams())
      .then(res => {
        setBodiesForTimes(res.data)
        if(res.data.length === 1){
          setValue(res.data[0].QualColId)
        }
      })
  })

  useAfterUpdateEffect(() => {
    props.onChange(value)
  }, [value])

  if(bodiesForTimes.length > 1){
    return <div className="mr-2" style={{minWidth: 150}}>
      <Select
        placeholder={'Wybierz opcje...'}
        onChange={setValue}
        options={bodiesForTimes.map(bodyForTimes => ({
          label: bodyForTimes.QualColText,
          value: bodyForTimes.QualColId,
        }))}
        value={value}
      />
    </div>;
  }

  return null
};

BodyForTimesSelect.propTypes = {
};

export default BodyForTimesSelect;